'use client'

import dynamic from 'next/dynamic'

const HomePage = dynamic(() => import('@/app/_pages/HomePage.jsx').then((module) => module.HomePage), {
  ssr: false,
})

export default function HomeClient({ initialNews = null }) {
  return <HomePage initialNews={initialNews} />
}
